export interface IResetPasswordState {
    userId: string;
    email: string;
    passwordToken: string;
    fromInvitation: boolean;
    newPassword: string;
    loading: boolean;
    authenticated: boolean;
    resetFail: boolean;
    resetSuccess: boolean;
    resetFailText: string;
}

export const initialResetPasswordState: IResetPasswordState = {
    userId: null,
    email: null,
    passwordToken: null,
    fromInvitation: null,
    newPassword: null,
    loading: false,
    authenticated: false,
    resetFail: false,
    resetSuccess: false,
    resetFailText: ''
};
